import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

interface ViewProps {
    dispatch: ReturnType<typeof useAppDispatch>;
    location: ReturnType<typeof useLocation>;
    navigate: ReturnType<typeof useNavigate>;
}

export const useConstraints = (): ViewProps => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    return {
        dispatch,
        location,
        navigate
    };
};
